import React from "react";
import {hasDeliveryInstructionsCapability} from "../../lib/Couriers";

const CourierDeliveryInstructions = ({courierId, instructions}) => {

  if (!hasDeliveryInstructionsCapability(courierId)) return (
    <div className="CourierDeliveryInstructions">
      <span>(Not applicable for {courierId})</span>
    </div>
  )

  if (instructions === "") return (
    <div className="CourierDeliveryInstructions">
      <span>(Not specified)</span>
    </div>
  )

  return (
    <div className="CourierDeliveryInstructions u-specified">
      <span>{instructions}</span>
    </div>
  )

}

export default CourierDeliveryInstructions;